module.exports = __webpack_public_path__ + "img/a5-s13.e54e0997.jpg";